// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.justify-start {
  margin-right: 73%;
}

.end {
  text-align: center;
  margin: auto;
}

.end-p {
  margin-top: auto;
  margin-bottom: auto;
}

.responsible-person-span {
  cursor: pointer;
}

.more-options {
  margin-left: 4%;
}

.left-gap {
  margin-left: 5px;
}

.right-gap {
  margin-right: 0px;
}

.nextLabel {
  display: flex;
  margin-bottom: 0;
  margin-left: 50px;
  min-width: 75px;
}

.current-steps {
  margin-top: 5px;
  margin-bottom: 5px;
}

.step-options {
  display: flex;
  width: 100%;
  text-align: right;
  flex-wrap: wrap;
  justify-content: flex-end;
  margin: auto;
  row-gap: 10px;
}

.top-gap {
  margin-top: 5px !important;
}

.bottom-gap {
  margin-bottom: 5px !important;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
